import React,{useEffect, useState} from 'react'
import NavbarBottom from '../components/NavbarBottom'
import phoneIcon from '../assets/phone-call.png'


export default function Profile() {
    const [phone, setPhone] = useState(null);

  const userData = JSON.parse(sessionStorage.getItem('AI_UserData'))

  useEffect(()=>{
    console.log(userData)
    if(userData){
      setPhone(userData.phone)
      console.log(phone)
    }
  },[])






  const setCookie = (name, value, days) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000); // Expiry in days
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  };

  const removeCookie = (name) => {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
  };

  const handleAddCookie = () => {
    setCookie("googtrans", "/en/id", 7); // Cookie valid for 7 days
    window.location.reload()

  };

  const handleRemoveCookie = () => {
    removeCookie("googtrans");
    window.location.reload()
   
  };




  return (
    <>
      <div className='container pt-4 ' style={{ marginBottom: "12rem" }} >

        <h1>Profile</h1>
        <div style={{ background: '#ffffff91' }}
          className='d-flex align-items-center gap-4 mt-5 justify-content-between p-4 br_10' >
          <div className='d-flex align-items-center gap-4' >

          <img style={{ maxHeight: '30px' }} src={phoneIcon} />

            <div>
              <h1 className='p-0 m-0' >{phone}</h1>
            </div>
          </div>

        </div>


        <div style={{ background: '#ffffff91' }}
          className='d-flex flex-column align-items-center gap-4 mt-5  p-4 br_10' >

          <div className='d-flex align-items-center justify-content-between w-100' >
            <h2>Languages</h2>

            <div className='d-flex gap-2' >
              <span className='lang_span' onClick={()=>handleRemoveCookie()} >English</span>
              <span className='lang_span' onClick={()=>handleAddCookie()} >Bahasa</span>
            </div>

          </div>


          <div className='separator' ></div>

          <div className='d-flex align-items-center justify-content-between w-100 ' >
            <h2  onClick={()=>window.location.href='/Portal/privacy'}  >Privacy Policy</h2>
          </div>
          <div className='separator' ></div>

          <div className='d-flex align-items-center justify-content-between w-100 ' >
            <h2 onClick={()=>window.location.href='/Portal/terms'} >Terms And Conditions</h2>
          </div>
          <div className='separator' ></div>




        </div>
      </div>

      <NavbarBottom />
    </>
  )
}
